import { render, staticRenderFns } from "./UserInfoChange.vue?vue&type=template&id=448a9014&scoped=true&"
import script from "./UserInfoChange.vue?vue&type=script&lang=js&"
export * from "./UserInfoChange.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoChange.vue?vue&type=style&index=0&id=448a9014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a9014",
  null
  
)

export default component.exports